export default "__VITE_ASSET__CvNEx7xt__"